<template>
  <div class="statistics">
    <!-- 面包屑 -->
    <breadcrumb></breadcrumb>
    <div class="echars">
      <tpl-detail titName="数据统计">
        <template slot="titRight">
          <download-all-zip
            url="/research/exportResearchInfo"
          ></download-all-zip>
        </template>
        <template slot="body">
          <div class="body-box" v-loading="loading">
            <el-row>
              <el-col :span="4">
                <div class="tu">
                  <div
                    style="width: 100%; height: 100%"
                    class="chart-class"
                    ref="chart"
                  ></div>
                </div>
              </el-col>
              <el-col :span="4">
                <h3>活动教师</h3>
                <h4>
                  {{
                    statisticsInfo && statisticsInfo.activeStatistics.userCount
                  }}人
                </h4>
              </el-col>
              <el-col :span="7">
                <h3>签到教师</h3>
                <h4>
                  签到:
                  {{
                    statisticsInfo &&
                    statisticsInfo.activeStatistics.firstSignCount
                  }}人
                  <!-- /签退: {{ statisticsInfo && statisticsInfo.activeStatistics.secondSignCount }}人 -->
                </h4>
              </el-col>
              <el-col :span="4">
                <h3>活动环节</h3>
                <h4>
                  {{
                    statisticsInfo &&
                    statisticsInfo.activeStatistics.nodeTopicCount
                  }}个
                </h4>
              </el-col>
              <el-col :span="4">
                <h3>活动成果</h3>
                <h4>
                  {{
                    statisticsInfo &&
                    statisticsInfo.activeStatistics.activeResultCount
                  }}个
                </h4>
              </el-col>
              <!-- <el-col :span="3">
								<h3>发言/回复数</h3>
								<h4>{{statisticsInfo && statisticsInfo.activeStatistics.speakCount}}个</h4>
							</el-col>-->
            </el-row>
          </div>
        </template>
      </tpl-detail>
    </div>

    <div class="hj">
      <tpl-detail titName="活动环节">
        <template slot="body">
          <ul>
            <li
              class="clearfix"
              v-for="(i, index) in statisticsInfo.nodeTopicStatistics"
              :key="index"
              @click="toPathLink(i)"
            >
              <span class="fl">{{ index + 1 }}</span>
              <div class="fl">
                <h1>{{ i.topic }}</h1>
                <h2>
                  <i :class="mapLinkIcon(i.nodeType)"></i>
                  {{ i.nodeTypeDesc }}
                  <!-- <span class="cyd">参与度：{{i.documentParticipation}}%</span> -->
                </h2>
              </div>
              <div class="right-box fr">
                <i class="el-icon-arrow-right fr"></i>
                <div class="fr">
                  <h6>{{ statis1(i) }}</h6>
                  <!-- <h6>{{statis2(i)}}</h6> -->
                </div>
              </div>
            </li>
          </ul>
        </template>
      </tpl-detail>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import TplDetail from "@/templates/TplDetail.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapFileIcon, mapLinkIcon } from "@/utils/index.js";
import { mapState } from "vuex";
import downloadAllZip from "@/components/downloadAllZip.vue";
export default {
  components: {
    Breadcrumb,
    TplDetail,
    downloadAllZip,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      loading: true,
      statisticsInfo: "",
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    mapLinkIcon,
    async init() {
      this.loading = true;
      this.statisticsInfo = await getData("/research/getActiveStatisticsInfo", {
        actCode: sessionStorage.getItem("actCode"),
        isSub: 0,
      });
      //查询活动参与人信息
      // getData("/research/getActiveUserMapList", {
      // 	actCode: sessionStorage.getItem("actCode")
      // });
      this.initCharts();
      this.loading = false;
    },
    toPathLink(node) {
      //moduleType: "" //eduResearch 教研活动 	train 培训  topicResearch 项目课题研究
      this.$router.push({
        name: "eduResearchGroupPartake",
        query: {
          nodeCode: node.nodeCode,
          moduleType: "eduResearch",
          nodeType: node.nodeType,
          actCode: sessionStorage.getItem("actCode"),
        },
      });
    },
    initCharts() {
      let bgColor = "#fff";
      let title = "签到率";
      let bfh = "%";
      let color = ["#F0F2F5", "#1890FF"];
      let echartData = [
        {
          name: "未签到",
          value: 100 - this.statisticsInfo.activeStatistics.participation,
        },
        {
          name: "已签到",
          value: this.statisticsInfo.activeStatistics.participation,
        },
      ];
      let option = {
        backgroundColor: bgColor,
        color: color,
        title: [
          {
            text:
              "{name|" +
              title +
              "}\n{val|" +
              this.statisticsInfo.activeStatistics.participation +
              "}{c|" +
              bfh +
              "}",
            top: "center",
            left: "center",
            textStyle: {
              rich: {
                name: {
                  fontSize: 12,
                  fontWeight: "normal",
                  color: "#666666",
                  padding: [10, 0],
                },
                val: {
                  fontSize: 22,
                  fontWeight: "bold",
                  color: "#1890FF",
                },
                c: {
                  fontSize: 22,
                  fontWeight: "bold",
                  color: "#1890FF",
                },
              },
            },
          },
          {
            top: 20,
            left: 20,
            textStyle: {
              fontSize: 14,
              color: "#666666",
              fontWeight: 400,
            },
          },
        ],
        series: [
          {
            type: "pie",
            radius: ["45%", "60%"],
            center: ["50%", "50%"],
            data: echartData,
            hoverAnimation: false,
            label: {
              show: false,
              position: "center",
            },
          },
        ],
      };

      this.$nextTick(() => {
        let myChart = this.$echarts.init(this.$refs.chart);
        myChart.setOption(option);
      });
    },
    //查看下载量统计
    //speakCount 发言
    //replyCount 回复
    //browseCount 查看
    //downloadCount 下载
    statis1(i) {
      let nodeType = i.nodeType;
      switch (nodeType) {
        case "speak":
        case "note":
        case "experience":
        case "summary":
        case "harvest":
          return i.speakReplyCount + "人参与";
        case "survey":
          return i.surveyCount + "人参与";
        case "eval":
          return i.evalCount + "人参与";
        case "homework":
          return i.homeworkCount + "人参与";
        default:
          return i.documentCount + "人参与";
      }
    },
    statis2(i) {
      let nodeType = i.nodeType;
      if (["speak", "eval", "survey"].includes(nodeType)) {
        return i.replyCount + "人回复";
      } else {
        return i.downloadCount + "人下载";
      }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.statistics {
  // padding: 10px 20px;
  .echars {
    margin-top: 15px;
    .body-box {
      padding: 15px 10px;
      text-align: center;
      font-size: 18px;
      .tu {
        margin: 0 auto;
        width: 210px;
        height: 210px;
      }
      h3 {
        margin-top: 60px;
        font-size: 19px;
      }
      h4 {
        margin-top: 15px;
        font-size: 25px;
        color: @color;
      }
    }
  }
  .hj {
    //环节
    ul {
      padding-left: 10px;
      li {
        padding: 8px;
        padding-left: 15px;
        background-color: #f1f1f1;
        border-radius: 5px;
        cursor: pointer;
        margin-bottom: 15px;
        span {
          margin-top: 8px;
          border: 2px solid @color;
          color: @color;
          height: 30px;
          width: 30px;
          font-size: 20px;
          border-radius: 50%;
          text-align: center;
          line-height: 25px;
        }
        h1 {
          font-size: 15px;
          padding-left: 15px;
        }
        h2 {
          margin-top: 2px;
          font-size: 12px;
          padding-left: 15px;
          color: @hui;
          i {
            color: @color;
            font-size: 13px;
          }
          .cyd {
            font-size: 13px;
            margin-left: 20px;
            color: @color;
            border: none;
          }
        }
        .right-box {
          width: 200px;
          h6:nth-of-type(1) {
            margin-top: 3px;
            font-size: 14px;
            color: #000;
            text-align: center;
            line-height: 40px;
          }
          h6:nth-of-type(2) {
            font-size: 12px;
            color: @hui;
            text-align: center;
            line-height: 20px;
          }
          i {
            // border: 1px solid #000;
            font-size: 30px;
            margin: 10px 20px 0px 20px;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
